export class Environment {
    private static SERVERS = {
        'TEST': 'http://localhost:9018',
        'TEST109': 'http://10.175.2.120:9015',
        'DEV': 'https://sugu-dev.orange-sonatel.com',
        'DEVIP': 'http://10.100.238.111:9015',
        'PROD': 'https://sugu-web-https-dsiosnsugu-prod.apps.malaw-prod.orange-sonatel.com',
        'PREPROD': 'https://sugu-web-preprod-dsiosnsugu-isoprod.apps.malaw-prod.orange-sonatel.com',
        // 'PREPROD': 'https://sugu-web-preprod-dsiosnsugu-isoprod.apps.malaw-prod.orange-sonatel.com',
        'IMPLICIT': ''
    };
    private static  TYPE: 'DEV' | 'PROD' | 'TEST' | 'TEST109' | 'DEVIP' | 'IMPLICIT' | 'PREPROD' = 'IMPLICIT';
    static get SERVER () {
        // return this.SERVERS['TEST'] + '/api/v1';
        return this.SERVERS[this.TYPE] + '/api/v1';
    }
    static get BASE () {
        // return this.SERVERS['TEST'];
        return this.SERVERS[this.TYPE];
    }
}
